import React from 'react';
import { Spin as AntSpin } from 'antd';

/**
 * Wrapper component for Ant Design Spin
 * 
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design Spin functionality including size, tip, and spinning state.
 * 
 * @component
 * @example
 * import { Spin } from '../GeneralComponents/ui';
 * 
 * <Spin />
 * <Spin size="small" />
 * <Spin size="large" />
 * <Spin tip="Loading...">
 *   <div>Content</div>
 * </Spin>
 * 
 * @see https://ant.design/components/spin/ - Ant Design Spin documentation
 */
const Spin = (props) => {
  return <AntSpin {...props} />;
};

export default Spin;

